import _ from "lodash";
import { checkFieldName } from "../utils";
import parse from "html-react-parser";
import { ThemeDisplay } from "./DisplayThemes";

export const DisplayValue = ({
  name,
  value,
  model,
  className,
  type,
}: {
  name: string;
  model?: string;
  value: any;
  type?: string;
  className?: string;
}) => {
  const [displayName] = checkFieldName(name, model);
  return (
    <div className="flex text-sm font-medium">
      <div className="min-w-[12rem]">{displayName} :</div>
      {model === "stories" && name === "themes" ? (
        <ThemeDisplay value={value} />
      ) : type === "image" ? (
        <div className="flex flex-col gap-2">
          <div className="opacity-30 text-sm">{value || "No image"}</div>
          {value && (
            <div className={"w-full max-w-[24rem]"}>
              <img src={value} />
            </div>
          )}
        </div>
      ) : type === "wysiwyg" && value ? (
        <div className={className}>{parse(value)}</div>
      ) : type === "string_array" ? (
        <div className="flex flex-wrap gap-x-2">
          {value &&
            value.map((v: string, index: number) => (
              <span key={index} className="py-0.5 px-1 bg-grayBg">
                {v.replaceAll('"', "")}
              </span>
            ))}
        </div>
      ) : type === "number" || value !== undefined ? (
        <div className={className}>{_.toString(value)}</div>
      ) : (
        <div className="opacity-30">Empty</div>
      )}
    </div>
  );
};
